<script setup>
import { onMounted, ref, inject, computed } from 'vue'
import { usePortAllData } from '@/stores/portAllData'
import MainMap from '../components/MainMap.vue'
import { getAuthorizedConfig } from '../plugins/utils/Authorization.js'
import { storeToRefs } from 'pinia'

const store = usePortAllData();
const $config = inject('$config')
const $socket = inject('$socket')
const { setAuthConfig, setMeasureUnit } = store;
const { getMeasureUnit, getIsMobile, getOnline } = storeToRefs(store)
const isMounted = ref(false);

onMounted(async () => {
  if ($socket && !getOnline.value) {
    $socket.forceReconnect()
  }
  if (!getMeasureUnit.value) {
    const defaultMeasureUnit = $config.viewOptions.defaultMeasureUnit
    setMeasureUnit(defaultMeasureUnit)
  }
  const authConfig = getAuthorizedConfig()

  if (authConfig) {
    setAuthConfig({ ...authConfig })
    isMounted.value = true
  }
})

const mobileApple = computed(() => {
  let isApple = false;
  if (navigator?.userAgent.indexOf('Mac') !== -1) isApple = true;
  return getIsMobile.value && isApple
});
</script>

<template>
  <main :class="{ 'apple-mobile': mobileApple }">
    <main-map v-if="isMounted" />
  </main>
</template>
